import Divider from '@mui/material/Divider';
import { observer } from 'mobx-react-lite';
import { ValidationError } from '../../../../components';
import Product from '../../store/Product';
import classes from './ProductValidation.module.scss';

export default observer(function ProductValidation({
  product,
}: {
  product: Product;
}) {
  const errors = product.allErrorsAsStrings;

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Divider className={classes.divider} />
      <ValidationError error={product.allErrorsAsStrings} />
    </div>
  );
});
